import React, { useState } from "react";
import backButtonIcon from "../../assets/images/BackButton.png";
import { useNavigate } from "react-router-dom";
import CommonPopup from "../../components/common/CommonPopup"; // adjust path if needed
import feedbackIcon from "../../assets/images/Feedback.png";
import SubHeader from "../../components/Header/SubmenuHeader";


const StarRating = ({ rating, setRating }) => {
  return (
    <div className="flex justify-center space-x-2 mt-2 mb-6">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          onClick={() => setRating(star)}
          className={`text-4xl cursor-pointer transition-transform duration-200 ${
            star <= rating ? "text-yellow-400" : "text-gray-300"
          }`}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default function FeedbackForm() {
  const [webRating, setWebRating] = useState();
  const [lockerRating, setLockerRating] = useState(0);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [result, setResult] = useState("");
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    setResult("Sending...");

    const payload = {
      // Web3Forms login: sales@themailwhale.in
      access_key: "dadfe023-7179-4d71-a2a2-400243975381",
      subject: "TMW Feedback Form",
      message: `
      Web App Feedback: ${webRating}
      Locker Screen Feedback: ${lockerRating}
      Subject: ${subject}
      Message: ${message}
      Timestamp: ${new Date().toLocaleString()}
    `,
      botcheck: "",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.success) {
        setResult("✅ Submitted successfully!");
        setShowPopup(true);

        setSubject("");
        setMessage("");
        setWebRating(0);
        setLockerRating(0);
        //   setTimeout(() => setResult(""), 3000);
      } else {
        setResult(data.message || "❌ Failed to submit feedback.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setResult("❌ Network error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#CCE9FF] to-white flex flex-col">
      {/* Top header remains fixed at top */}
            <SubHeader title={"Feedback"} />
      {/* <header className="w-full bg-[#004990] px-4 py-4 relative z-50">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="text-white hover:bg-white/10 p-1 rounded-full"
          >
            <img
              src={backButtonIcon}
              alt="Back"
              className="w-[22.22px] h-[22.22px] object-contain"
            />
          </button>
            <div className="flex items-center gap-3 ml-4 text-white">
              <img
                src={feedbackIcon}
                alt="Feedback Icon"
                className="w-[28px] h-[28px] object-contain"
              />
              <h1 className="font-semibold text-lg">FeedBack</h1>
            </div>
        </div>
      </header> */}

      {/* Centered Feedback Form */}
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="w-full max-w-xl bg-white shadow-lg p-6 text-center flex flex-col items-center justify-center rounded-lg">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            TMW Feedback{" "}
            <span role="img" aria-label="star">
              ⭐
            </span>
          </h1>

          <p className="text-md font-medium text-gray-700">
            How Our <strong>WEB APP</strong> Been Helpful For You?
          </p>
          <StarRating rating={webRating} setRating={setWebRating} />

          <p className="text-md font-medium text-gray-700">
            How Our <strong>TMW Locker Screen</strong> Been Helpful For You?
          </p>
          <StarRating rating={lockerRating} setRating={setLockerRating} />

          <form onSubmit={handleSubmit} className="space-y-4 mt-6 w-full">
            <input
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <textarea
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px]"
            />
            <button
              type="submit"
              className="w-full bg-blue-500 text-white font-semibold py-3 rounded-lg hover:bg-blue-600 transition"
            >
              {result.startsWith("Sending") ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
      {showPopup && (
        <CommonPopup
          isOpen={showPopup}
          icon={"✅ "}
          title="Submitted Successfully!"
          message="Thank you for your valuable feedback."
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
}
